$( document ).ready(function() {
    
    var isMobile = $('#Details-menu-drawer-container').is(':visible');
    
    // // toggle mobile menu submenus
    // $(".custom-submenu-toggle").on("click", function() {
    //     $(this).next().toggleClass("open-menu");
    // });

    // toggle mega menu on hover (desktop)
    $('details.mega-menu').hover(
        function() {
            $(this).attr("open", "open");
        }, function() {
            $(this).removeAttr("open", "open"); 
        }
    );

    /// POPUP FOR SIZE TABLE
    function closePopup() {
        // Hide the popup
        $('#popupContainer').hide();

        // Remove the ESC key press listener
        $(document).off('keydown');
    }


    $('#popupButton').click(function() {
        // Check if a table exists in the .product__description div
        if ($('.product__description table').length > 0) {
            // Clone the table
            var clonedTable = $('.product__description table').clone();

            // Append the cloned table to the popup container
            $('#popupContent').empty().append(clonedTable);

            // Display the popup
            $('#popupContainer').show();

            $(document).on('keydown', function(e) {
                if (e.key === 'Escape') {
                    closePopup();
                }
            });
        }
    });

    $('#popupClose').click(function() {
        closePopup();
    });

    if ($('.product__description table').length == 0) {
        $('#popupButton').hide();
    }
    /// END POPUP FOR SIZE TABLE

    // floating message, newsletter 
    var floatingMsgDismissed = sessionStorage.getItem('_floatingMsgDismissed'); // get the key
    if (floatingMsgDismissed) {
    } else {
        $("#floatingMsg").toggleClass("active");
    }

    $("#floatingMsgClose").on( "click", function(e) {
        sessionStorage.setItem('_floatingMsgDismissed', true);
        $("#floatingMsg").toggleClass("active");
    });



    // toggle links visibility in footer on mobile
    if(isMobile) {
        $(".footer-block__heading ").on( "click", function(e) {
            $(this).next(".footer-block__details-content").toggleClass("active");
        });
    }


    // product card thumbnail - init slider
    $('.card__variant--thumbs .thumbs-wrapper').slick({
        infinite: false,
        slidesToShow: 3,
        variableWidth: true,
        slidesToScroll: 1,
    });


    // vertical slider (desktop) on product pages
    if( $("html.page-name-product").length ) {

        // init slider
        $('ul.thumbnail-list.slider').slick({
            slidesToScroll: 1,
            slidesToShow: 6,
            vertical: true,
            responsive: [
                {
                    // disable vertical slider below 1024px screen width
                    breakpoint: 1024,
                    settings: "unslick"
                },
            ]
        });

        
        // update slider on change of window width
        $(window).on('resize orientationchange', function() {
            if(  !$('ul.thumbnail-list.slider').hasClass('slick-initialized')) {
                $('ul.thumbnail-list.slider').slick('reinit');
            }
        });
    }


    // wrap tables in content for mobile friendly reasons
    $("#MainContent table").wrap("<div class='responsive-table'></div>");

    // shops overview page: wrap adres & opening hours
    if( $("html.page-template-shops-overview").length ) {

        $(".banner").each(function() {
            $(this).find(".banner__text:not(:first)").wrapAll("<div class='shopinfo'></div>");
        });
    }

    // Function to initialize price range sliders
    window.initPriceRangeSliders = function() {
        const rangeInput = document.querySelectorAll(".range-input input");
        const priceInput = document.querySelectorAll(".price-input input");
        const range = document.querySelector(".slider .progress");
        
        if (!rangeInput.length || !priceInput.length || !range) return;
        
        let priceGap = 1;

        priceInput.forEach((input) => {
            input.addEventListener("input", (e) => {
                const currentRangeInput = document.querySelectorAll(".range-input input");
                const currentPriceInput = document.querySelectorAll(".price-input input");
                const currentRange = document.querySelector(".slider .progress");
                
                let minPrice = parseInt(currentPriceInput[0].value);
                let maxPrice = parseInt(currentPriceInput[1].value);

                if (maxPrice - minPrice >= priceGap && maxPrice <= currentRangeInput[1].max) {
                    if (e.target.className === "input-min") {
                        currentRangeInput[0].value = minPrice;
                        currentRange.style.left = (minPrice / currentRangeInput[0].max) * 100 + "%";
                    } else {
                        currentRangeInput[1].value = maxPrice;
                        currentRange.style.right = 100 - (maxPrice / currentRangeInput[1].max) * 100 + "%";
                    }
                }
            });
        });

        rangeInput.forEach((input) => {
            input.addEventListener("input", (e) => {
                const currentRangeInput = document.querySelectorAll(".range-input input");
                const currentPriceInput = document.querySelectorAll(".price-input input");
                const currentRange = document.querySelector(".slider .progress");
                
                let minVal = parseInt(currentRangeInput[0].value);
                let maxVal = parseInt(currentRangeInput[1].value);

                if (maxVal - minVal < priceGap) {
                    if (e.target.className === "range-min") {
                        currentRangeInput[0].value = maxVal - priceGap;
                    } else {
                        currentRangeInput[1].value = minVal + priceGap;
                    }
                } else {
                    currentPriceInput[0].value = minVal;
                    currentPriceInput[1].value = maxVal;
                    currentRange.style.left = (minVal / currentRangeInput[0].max) * 100 + "%";
                    currentRange.style.right = 100 - (maxVal / currentRangeInput[1].max) * 100 + "%";
                }
            });
        });
    };

    // Initialize on page load
    initPriceRangeSliders();

    const lang = $('html').attr('lang');

    //const linkTags = document.head.querySelectorAll("link[rel='alternate']:is([hreflang='nl-NL'], [hreflang='en-GB'], [hreflang='de-DE'])");
    const linkTags = document.querySelectorAll(".lang-helper-iso-code");
    const languageSwitchDesktop = document.getElementById('HeaderLanguageDesktopList');
    const languageSwitchMobile = document.getElementById('HeaderLanguageList');

    linkTags.forEach(link => {
        let a = document.createElement("a");
        //var locale = link.hreflang.split('-')[1];
        var locale = link.textContent.trim();
        var localeText = locale.toUpperCase();        // Set up locale code for data-value
        let localeCode = locale;
        if (localeCode === 'gb') localeCode = 'en';
        if (localeCode === 'nl') flagCode = 'nl';
        else if (localeCode === 'de') flagCode = 'de';
        else flagCode = 'gb';

        a.textContent = localeText;
        a.href = "#";
        a.setAttribute('data-value', localeCode);
        a.dataset.locale = localeCode; // for compatibility

        a.classList.add('link','link--text','disclosure__link','caption-large','focus-inset')
        a.dataset.locale = locale; // Add locale data attribute
        if (locale === lang) {
            a.classList.add("disclosure__link--active");
        }

        let li = document.createElement("li");
        let flagImg = document.createElement("img");
        flagImg.setAttribute('src', '//cdn.shopify.com/static/images/flags/'+flagCode+'.svg?width=24');
        a.appendChild(flagImg);
        li.classList.add('disclosure__item')
        li.appendChild(a)

        let clone = li.cloneNode(true);

        languageSwitchDesktop.appendChild(li);
        languageSwitchMobile.appendChild(clone);
    });


    // CUSTOM TRANSLATION FOR REVIEWS
    function waitForEl(selector, callback, maxtries = false, interval = 100) {
        const poller = setInterval(() => {
            const el = jQuery(selector)
            const retry = maxtries === false || maxtries-- > 0
            if (retry && el.length < 1) return // will try again
            clearInterval(poller)
            callback(el || null)
        }, interval)
    }


    const translations = [
        {
            "element": '.spr-header-title',
            "de": "Bewertungen",
            "en": "Reviews",
        },
        {
            "element": '.spr-summary .spr-summary-caption',
            "de": "Noch keine Bewertung",
            "en": "No reviews",
        },
        {
            "element": '.spr-summary-actions-newreview',
            "de": "Eine Bewertung schreiben",
            "en": "Write a review",
        },
        {
            "element": '.spr-summary-actions-togglereviews',
            "de": "Noch keine Bewertung",
            "en": "No reviews",
        },
        {
            "element": '.spr-review-reportreview',
            "de": "Als unangemessen melden",
            "en": "Report as inappropriate",
        },
        {
            "element": '.spr-summary-caption',
            "de": "",
            "en": "",
        },
        {
            "element": '.spr-form-title',
            "de": "Eine Bewertung schreiben",
            "en": "Write a review",
        },
        {
            "element": '.spr-form-contact-name .spr-form-label',
            "de": "Name",
            "en": "Name",
        },
        {
            "element": '.spr-form-contact-email .spr-form-label',
            "de": "E-Mail",
            "en": "Email",
        },
        {
            "element": '.spr-form-review-rating .spr-form-label',
            "de": "Ergebnis",
            "en": "Score",
        },
        {
            "element": '.spr-form-review-title .spr-form-label',
            "de": "Titel",
            "en": "Title",
        },
        {
            "element": '.spr-form-review-body .spr-form-label',
            "de": "Nachricht",
            "en": "Message",
        },
        {
            "element": '.spr-form-actions .spr-button',
            "de": "Senden",
            "en": "Send",
        },
        {
            "element": '.spr-starrating.spr-summary-starrating .spr-stars:nth-of-type(2)',
            "de": "Noch keine Bewertung",
            "en": "No reviews",
            "nl": "Nog geen beoordeling",
        },

    ];
        setTimeout(function(){
            translations.forEach(function(translation,index ) {
                waitForEl(translation.element, function(element){
                    if (translation[lang]) {
                        element.html(translation[lang]);
                    }
                })
            })
        }, 1000);


    // END CUSTOM


});

$(function() {
    const shopifyMeta = meta

    let searchParams = new URLSearchParams(window.location.search)
    if (meta.page.pageType == "product") {
        let variant = shopifyMeta.product.variants[0]
        if (searchParams.has('variant')) {
            let variantId = searchParams.get('variant');
            variant = shopifyMeta.product.variants.filter(function(v,i) {
                return v['id'] == variantId;
            })[0]
        }

        dataLayer.push({
            event: 'view_item',
            currency: "EUR",
            value: variant.price,
            items: [{
                item_id: variant.price,
                item_name: variant.name,
                item_brand: shopifyMeta.product.vendor
            }]
        });
    }

    if (meta.page.pageType == "collection") {

    }
});